import { AxiosError } from 'axios';

import { getApiClient } from './api.base';
import { getStoredToken } from '../session/account-store.service';
import { clearLoading, setLoading } from '@/services/utils/loading.service';
import { AccountProjectDonationResponse } from '@/models/account-project-donations-response.model';

type Response = AccountProjectDonationResponse & AxiosError;

export const userProjectDonationsService = async (
  projectId: string,
  query: string,
): Promise<Response> => {
  setLoading();
  try {
    const token = getStoredToken();
    const response = await getApiClient('auth', token ?? '').get(
      `/api/v1/account/project/${projectId}/donations?${query}`,
    );
    clearLoading();
    return response.data as Response;
  } catch (errorResponse) {
    const error = errorResponse as Response;
    console.info(error);
    clearLoading();
    return error;
  }
};
